export const labels = {
  manageLabelsTitle: 'Manage labels',
  manageLabelsPara: 'Edit and manage labels in the configuration template',
  code: 'Code',
  codePlaceholder: 'Enter label code',
  label: 'Label',
  labelPlaceholder: 'Enter label name',
  defaultValue: 'Default value',
  defaultValuePlaceholder: 'Enter default value',
  isVisible: 'Visible',
  visible: 'Visible',
  hidden: 'Hidden',
  edit: 'Edit',
  delete: 'Delete',
  addLabel: 'Add label',
  save: 'Save',
  cancel: 'Cancel',
  noLabels: 'This configuration has no added labels',
  deletingLabel: 'Delete label',
  deletingLabelDescription:
    'Are you sure you want to delete this label? This action cannot be undone.',
  addingNewLabel: 'Adding new label',
  updatedIndexSuccess: 'Label order updated successfully',
  createdSuccess: 'Label created successfully',
  updatedSuccess: 'Label updated successfully',
  deletedSuccess: 'Label deleted successfully',
}
